<template lang="pug">
.audit-sub-item(:class="showTopBorder ? 'show__border__top' : ''")
  .audit-sub-item__title(:class="[showContent ? 'content__extend' : 'content__collapse']")
    .sub-item__title__left
      i.el-icon-arrow-right(
        @click="changeContentStatus"
      )
      span {{ data.sub_final_scope_name }}
      span(v-if="isZh") {{ data.vendor }}{{ $t('家供应商') }}
      span(v-else) {{ data.vendor }} vendors
    .sub-item__title__right
      span {{ data.category[0].category_name }}
      span {{ data.category[0].children.length !== 0 ? '：' + data.category[0].children.map(i => i.scope_name).join(',') : '' }}
  transition-group(name="fade")
    template(v-for="(v,i) in data.sub_final_scope_vendor")
      .audit-sub-item__content__container(v-if="showContent" :key="i")
        audit-sub-item-content(
          :data="v"
          @confirm="remark => handleAudit('confirm', remark)"
          @reject="remark => handleAudit('reject', remark)"
          @update="$emit('update')"
          :parentIndex="index"
          :index="i"
          :isNeedIT="isNeedIT"
        )

</template>

<script>
import AuditSubItemContent from './AuditSubItemContent'
import db from '@/umcc/db'

export default {
  components: {
    AuditSubItemContent
  },
  mounted () {
    this.$store.commit('campaign/setQuotationExtendOrder', {
      '0': true,
      '0.0': true
    })
  },
  computed: {
    showTopBorder () {
      return this.index === 0
    },
    showContent () {
      return this.$store.state.campaign.quotationExtendOrder[this.index]
    },
    isZh () {
      return db.lang === 'zh'
    }
  },
  methods: {
    changeContentStatus () {
      const qeo = this.$store.state.campaign.quotationExtendOrder
      this.$set(qeo, this.index, !this.showContent)
    }
  },
  props: {
    data: {
      type: Object,
      default () {
        return []
      }
    },
    isNeedIT: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default () {
        return 0
      }
    }
  }
}
</script>

<style lang="stylus">
.audit-sub-item
  border-bottom 1px solid #d8d8d8
  margin-right -32px
  margin-left -32px
  &.show__border__top
    border-top 1px solid #d8d8d8
.audit-sub-item__title
  display flex
  justify-content space-between
  align-items center
  padding: 0 32px 0 12px
  height 58px
  .sub-item__title__left
    i
      font-weight 600
      cursor pointer
    span
      &:nth-child(2)
        margin-left 5px
        color #2c3031
        font-size 16px
      &:nth-child(3)
        color #808080
        font-size 12px
        margin-left 32px
  .sub-item__title__right
    span
      color #808080
      font-size 12px
  &.content__extend
    background #edf2fa
    border-bottom 1px solid #d8d8d8
    i
      transform: rotateZ(90deg)
      transition transform .3s
  &.content__collapse
    i
      display inline-block
      transform: rotateZ(0deg)
      transition transform .3s
  > span
      color #808080
      font-size 14px
</style>
